module.exports = __webpack_public_path__ + "img/dog.5960d887.png";